// extracted by mini-css-extract-plugin
export default {"content":"NftLabelAndContent_content__vpHvh","inline":"NftLabelAndContent_inline__srm8G"};